module.exports = __webpack_public_path__ + "static/media/office-960.5ff881c9.jpg";